module.exports = __webpack_public_path__ + "static/media/TestimonialBG.3b5d508c.jpg";